import * as classNames from "classnames";
import * as React from 'react';
import Expandable from '../../common/Expandable';
import ScanChart from '../ScanChart';

interface ITimeSummaryProps {
    className: any,
    height: any,
    title: any
}

interface ITimeSummaryActions {
}

type TimeSummaryProps = ITimeSummaryProps & ITimeSummaryActions;

class TimeSummary extends React.Component<TimeSummaryProps, any> {
    constructor(props, context) {
        super(props, context);
        this.state = { showChart: true };
        this.onToggleShowClicked = this.onToggleShowClicked.bind(this);
    }
    onToggleShowClicked() {
        this.setState({ showChart: !this.state.showChart });
    }

    render() {

        let timeOfDayColours = ['#FF9513', '#FFED35', '#404040'];

        return (
            <div className={classNames("mx-0 px-0", this.props.className)}>

                <Expandable title={this.props.title} allowClose={false} allowExpand={true} defaultClosed={true}>
                    <div className="mx-2 my-2">
                        <div style={{ width: "100%" }}>
                            <div className="row no-gutters my-0 mx-2">
                                <div className={classNames("col-8")}>
                                    <div className="row no-gutters">
                                        <div className="col-6">
                                            <strong>Data</strong>
                                        </div>
                                        <div className="col-3 text-center"><strong>Count</strong></div>
                                        <div className="col-3 text-center"><strong>%</strong></div>
                                    </div>
                                </div>
                                <div className={classNames("col-4")}>
                                    <ScanChart
                                        chartType='PieChart'
                                        collate={true}
                                        colors={timeOfDayColours}
                                        data={undefined}
                                        defaultClosed={undefined}
                                        discrete={undefined}
                                        displayIcon={undefined}
                                        groupBy={['eventStartDateTypeCode']}
                                        height={this.props.height ? this.props.height : "150px"}
                                        legend="none"
                                        title={undefined}
                                        width={undefined}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </Expandable>
            </div>

        );
    }
}

export default TimeSummary;
